import { API_BASE_URLS, API_URLS, APP_URLS } from '@/utils/core/apiUrls';

export const ssoConfig = {
    authServiceUrl: API_BASE_URLS.auth,
    redirectUrl: API_URLS.sso.redirectUrl,
    callbackUrl: API_URLS.sso.callbackUrl,
    refreshUrl: API_URLS.sso.refreshUrl,
    redirectUri: APP_URLS.ssoRedirectUri,
    tokenLifecycle: {
        jwtExpiry: 65 * 60 * 1000, // 65 minutes in milliseconds (exp = iat + 3900 s)
        refreshTrigger: 60 * 60 * 1000, // 60 minutes in milliseconds (65 - 5)
        bufferTime: 5 * 60 * 1000, // 5 minutes in milliseconds
    },
};
